import { render, staticRenderFns } from "./PicturesViewer.vue?vue&type=template&id=33debf5b&scoped=true&"
import script from "./PicturesViewer.vue?vue&type=script&lang=ts&"
export * from "./PicturesViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PicturesViewer.vue?vue&type=style&index=0&id=33debf5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33debf5b",
  null
  
)

export default component.exports